/**
 * BlogENAlmadarBlogPage
 *
 * Page component for BlogENAlmadarBlogPage
 * Path: /blog
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { BlogENBlogPageView as __BlogENBlogPageView } from '@/components/traits/BlogENBlogPageView';
import { BlogENBlogAnalyticsView as __BlogENBlogAnalyticsView } from '@/components/traits/BlogENBlogAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface BlogENAlmadarBlogPageProps {
  // Add any page-level props here
}

export function BlogENAlmadarBlogPage(_props: BlogENAlmadarBlogPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-blog:meta.title"],"description":["i18n/t","std-almadar-blog:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/blog"},{"locale":"ar","path":"/ar/blog"},{"locale":"sl","path":"/sl/blog"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__BlogENBlogPageView config={{ initPayload: __navState }} />
          <__BlogENBlogAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default BlogENAlmadarBlogPage;
